import { apiJson } from "./client";

/** @returns {Promise<import("./client").ApiJsonResult>} */
export function getMatchSocialBlocks() {
  return apiJson("/api/match-social/blocks", { method: "GET" });
}

/** @param {{ blockedUserId: number }} dto */
export function postMatchSocialBlock(dto) {
  return apiJson("/api/match-social/blocks", { method: "POST", body: dto });
}

/** @param {number} blockedUserId */
export function deleteMatchSocialBlock(blockedUserId) {
  return apiJson(`/api/match-social/blocks/${blockedUserId}`, { method: "DELETE" });
}

/** @param {number} matchId */
export function getMatchFriends(matchId) {
  return apiJson("/api/match-social/match-friends", { method: "GET", query: { matchId } });
}

/** @param {{ matchId: number, friendUserId: number }} dto */
export function postMatchFriend(dto) {
  return apiJson("/api/match-social/match-friends", { method: "POST", body: dto });
}

/** @param {{ matchId: number, friendUserId: number }} q */
export function deleteMatchFriend(q) {
  return apiJson("/api/match-social/match-friends", {
    method: "DELETE",
    query: { matchId: q.matchId, friendUserId: q.friendUserId }
  });
}

/** Remove all match-level friend links between you and this user. */
/** @param {number} friendUserId */
export function removeAllFriendLinks(friendUserId) {
  return apiJson("/api/match-social/friends/remove-all", {
    method: "POST",
    body: { friendUserId }
  });
}

export function getIncomingChatRequests() {
  return apiJson("/api/match-social/chat-requests/incoming", { method: "GET" });
}

export function getOutgoingChatRequests() {
  return apiJson("/api/match-social/chat-requests/outgoing", { method: "GET" });
}

/** @param {{ matchId: number, toUserId: number }} dto */
export function postPrivateChatRequest(dto) {
  return apiJson("/api/match-social/chat-requests", { method: "POST", body: dto });
}

/** @param {number} requestId */
export function acceptPrivateChatRequest(requestId) {
  return apiJson(`/api/match-social/chat-requests/${requestId}/accept`, { method: "POST" });
}

/** @param {number} requestId */
export function rejectPrivateChatRequest(requestId) {
  return apiJson(`/api/match-social/chat-requests/${requestId}/reject`, { method: "POST" });
}

export function getActivePrivateChats() {
  return apiJson("/api/match-social/chats/active", { method: "GET" });
}

/** @param {number} requestId @param {{ message: string }} body */
export function postPrivateChatMessage(requestId, body) {
  return apiJson(`/api/match-social/chat-requests/${requestId}/messages`, { method: "POST", body });
}

/** @param {number} requestId */
export function getPrivateChatMessages(requestId) {
  return apiJson(`/api/match-social/chat-requests/${requestId}/messages`, { method: "GET" });
}
